(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["better-to-know"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.better-to-know');
    if (!section) return;
    
    const scrollingContainer = section.querySelector('.scrolling-text-container');
    const scrollingWrapper = section.querySelector('.scrolling-text-wrapper');
    const lines = section.querySelectorAll('.scrolling-line');
    
    if (scrollingWrapper && lines.length > 0) {
      
      // Calculate perfect seamless loop timing
      const totalHeight = scrollingWrapper.scrollHeight;
      const sectionHeight = totalHeight / 3; // Each section is 1/3 of total
      const pixelsPerSecond = 20; // Adjust for desired speed
      const duration = sectionHeight / pixelsPerSecond;
      
      // Apply calculated duration for seamless loop
      scrollingWrapper.style.animationDuration = `${duration}s`;
      
      function updateLineEffects() {
        if (scrollingContainer && lines.length > 0) {
          const containerRect = scrollingContainer.getBoundingClientRect();
          const containerCenter = containerRect.top + containerRect.height / 2;
          const maxDistance = containerRect.height / 2;
          
          lines.forEach(line => {
            const lineRect = line.getBoundingClientRect();
            const lineCenter = lineRect.top + lineRect.height / 2;
            const distanceFromCenter = Math.abs(lineCenter - containerCenter);
            const normalizedDistance = Math.min(distanceFromCenter / maxDistance, 1);
            
            
            const opacity = Math.max(0.3, 1 - (normalizedDistance * 0.7));
            
            
            const scale = Math.max(0.5, 1 - (normalizedDistance * 0.5));
            
            
            line.style.opacity = opacity;
            line.style.transform = `scale(${scale})`;
          });
        }
      }
      
      
      function animate() {
        updateLineEffects();
        requestAnimationFrame(animate);
      }
      
      
      animate();
    }
    
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '0';
          entry.target.style.transform = 'translateX(-20px)';
          
          requestAnimationFrame(() => {
            entry.target.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateX(0)';
          });
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    observer.observe(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-monitoring-interactive"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.querySelector('.monitoring-modal');
    if (!modal) return;
    const modalTitle = modal.querySelector('.modal-title');
    const modalSubtitle = modal.querySelector('.modal-subtitle');
    const modalContent = modal.querySelector('.modal-content');
    const modalList = modal.querySelector('.modal-list');
    
    const devicePoints = document.querySelectorAll('.device-point');
    const satellitePoints = document.querySelectorAll('.satellite-point');
    const tagPoints = document.querySelectorAll('.tag-point');
    
    let activeDevice = null;
    let hideTimeout = null;
    let isModalHovered = false;
    let isDeviceHovered = false;
    
   
    function clearHideTimeout() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
    }
    
  
    function showModal(title, content, deviceType = null, subtitle = null) {
      clearHideTimeout();
      
      modalTitle.textContent = title;
      
      // Handle subtitle for tags and satellites only
      if (subtitle && (deviceType === 'tag' || deviceType === 'satellite')) {
        modalSubtitle.textContent = subtitle;
        modalSubtitle.classList.remove('hidden');
      } else {
        modalSubtitle.classList.add('hidden');
      }
      
      // Check if content has commas to convert to list (only for tags and satellites)
      if (content && content.includes(',') && (deviceType === 'tag' || deviceType === 'satellite')) {
        modalContent.textContent = ''; // Clear text content
        modalList.innerHTML = '';
        modalList.classList.remove('hidden');
        
        const items = content.split(',').map(item => item.trim()).filter(item => item);
        
        // Apply grid layout if more than 3 items
        if (items.length > 3) {
          modalList.classList.add('grid', 'grid-cols-2', 'gap-2');
        } else {
          modalList.classList.remove('grid', 'grid-cols-2', 'gap-2');
        }
        
        items.forEach(item => {
          const div = document.createElement('div');
          div.className = 'mb-2';
          div.textContent = '• ' + item;
          modalList.appendChild(div);
        });
      } else {
        modalContent.textContent = content;
        modalList.classList.add('hidden');
        modalList.classList.remove('grid', 'grid-cols-2', 'gap-2');
      }
      
      modal.classList.remove('opacity-0', 'pointer-events-none');
      modal.classList.add('opacity-100');
      modal.style.transform = 'translateY(0)';
    }
    
    
    function hideModalWithDelay() {
      clearHideTimeout();
      
      hideTimeout = setTimeout(() => {
        if (!isModalHovered && !isDeviceHovered) {
          modal.classList.add('opacity-0', 'pointer-events-none');
          modal.classList.remove('opacity-100');
          modal.style.transform = 'translateY(20px)';
          
         
          devicePoints.forEach(point => point.classList.remove('active'));
          satellitePoints.forEach(point => point.classList.remove('highlight'));
          tagPoints.forEach(point => point.classList.remove('highlight'));
          
          activeDevice = null;
        }
      }, 150); 
    }
    
   
    devicePoints.forEach(point => {
      point.addEventListener('mouseenter', function(e) {
        isDeviceHovered = true;
        clearHideTimeout();
        
        const deviceType = this.dataset.deviceType;
        const title = this.dataset.tooltipTitle;
        const content = this.dataset.tooltipContent;
        const subtitle = this.dataset.tooltipSubtitle;
        
    
        if (activeDevice && activeDevice !== this) {
          activeDevice.classList.remove('active');
          if (activeDevice.dataset.deviceType === 'tag') {
            tagPoints.forEach(tag => tag.classList.remove('highlight'));
          }
          else if (activeDevice.dataset.deviceType === 'satellite') {
            satellitePoints.forEach(satellite => satellite.classList.remove('highlight'));
          }
        }
         
  
        this.classList.add('active');
        activeDevice = this;
        
        if (deviceType === 'tag') {
         
          tagPoints.forEach(tag => tag.classList.add('highlight'));
          
          
          showModal(title, content, deviceType, subtitle);
        } else if (deviceType === 'satellite') {

        
          const satellitePoints = document.querySelectorAll('.satellite-point');
          satellitePoints.forEach(satellite => satellite.classList.add('highlight'));
          showModal(title, content, deviceType, subtitle);
        } else {
          showModal(title, content, deviceType, subtitle);
        }
      });
      
      point.addEventListener('mouseleave', function() {
        isDeviceHovered = false;
        hideModalWithDelay();
      });
    });
    
    // Keep modal open when hovering over it
    modal.addEventListener('mouseenter', function() {
      isModalHovered = true;
      clearHideTimeout();
      
      // Keep the modal visible
      this.classList.remove('opacity-0', 'pointer-events-none');
      this.classList.add('opacity-100');
      this.style.transform = 'translateY(0)';
    });
    
    modal.addEventListener('mouseleave', function() {
      isModalHovered = false;
      hideModalWithDelay();
    });
    
    // Mobile touch support
    let lastTouchTime = 0;
    devicePoints.forEach(point => {
      point.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          e.stopPropagation();
          
          // Prevent double-tap issues
          const currentTime = new Date().getTime();
          if (currentTime - lastTouchTime < 300) return;
          lastTouchTime = currentTime;
          
          const deviceType = this.dataset.deviceType;
          const title = this.dataset.tooltipTitle;
          const content = this.dataset.tooltipContent;
          
          alert(`${title}\n\n${content}`);
        }
      });
    });
    
    // Close modal when clicking outside on mobile
    document.addEventListener('click', function(e) {
      if (window.innerWidth < 768 && activeDevice && !e.target.closest('.device-point')) {
        hideModalWithDelay();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monitoring-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tooltip = document.querySelector('.monitoring-tooltip');
    const tooltipContent = document.querySelector('.tooltip-content');
    const callouts = document.querySelectorAll('.device-callout');

    if (!tooltip || !tooltipContent) return;

    callouts.forEach(callout => {
      callout.addEventListener('mouseenter', (e) => {
        const tooltipText = e.currentTarget.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        tooltipContent.textContent = tooltipText;
        tooltip.classList.remove('opacity-0');
        tooltip.classList.add('opacity-100');
        
        // Position tooltip
        const rect = e.currentTarget.getBoundingClientRect();
        const containerRect = tooltip.closest('.monitoring-illustration').getBoundingClientRect();
        
        const x = rect.left - containerRect.left + (rect.width / 2);
        const y = rect.top - containerRect.top - 10;
        
        tooltip.style.left = `${x}px`;
        tooltip.style.top = `${y}px`;
        tooltip.style.transform = `translateX(-50%) translateY(-100%)`;
      });

      callout.addEventListener('mouseleave', () => {
        tooltip.classList.remove('opacity-100');
        tooltip.classList.add('opacity-0');
      });

      // Mobile touch support
      callout.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          const tooltipText = e.currentTarget.getAttribute('data-tooltip');
          if (tooltipText && typeof alert !== 'undefined') {
            alert(tooltipText);
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resources-video-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-videos-more]');
    if (!button) return;
    var grid = document.getElementById(button.getAttribute('aria-controls'));
    if (!grid) return;
    var firstExtra = grid.querySelector('[data-video-extra]');
    grid.removeAttribute('data-collapsed');
    button.remove();
    if (firstExtra) firstExtra.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', async function() {
  console.log('DOM loaded, initializing sticky bar');
  
  // Exit early on mobile devices (below 1025px)
  if (window.innerWidth < 1025) {
    console.log('Sticky bar disabled on mobile');
    return;
  }
  
  const stickyBar = document.querySelector('[data-sticky-bar]');
  if (!stickyBar) {
    console.log('No sticky bar found');
    return;
  }
  
  const isSticky = stickyBar.classList.contains('sticky-product-bar--sticky');
  console.log('Sticky bar found, isSticky:', isSticky);
  
  if (!isSticky) {
    console.log('Not in sticky mode');
    return;
  }
  
  // Detect if there are upsells on the page
  function detectUpsells() {
    const upsellSelectors = [
      '.product-upsell',
      '[data-section-type="product-upsell"]',
      '.upsell-products',
      '.cross-sell',
      '[class*="upsell"]',
      '[id*="upsell"]'
    ];
    
    for (const selector of upsellSelectors) {
      const upsellElement = document.querySelector(selector);
      if (upsellElement) {
        console.log('Upsells detected:', selector);
        return true;
      }
    }
    
    console.log('No upsells detected');
    return false;
  }
  
  const hasUpsells = detectUpsells();
  stickyBar.setAttribute('data-has-upsells', hasUpsells);
  
  // Update button text if upsells are detected
  if (hasUpsells) {
    const addButton = stickyBar.querySelector('.sticky-product-bar__add-to-cart span');
    if (addButton && addButton.textContent.includes('Add to cart')) {
      addButton.textContent = 'View options';
    }
  }
  
  // Add body class to control header behavior via CSS
  document.body.classList.add('has-sticky-product-bar');
  
  // Wait for product-form-component to be defined before proceeding
  const findTriggerElement = async () => {
    // First ensure the component is defined
    if (customElements.get('product-form-component')) {
      await customElements.whenDefined('product-form-component');
    }
    
    let triggerElement = document.querySelector('product-form-component');
    
    if (!triggerElement) {
      // Fallback selectors
      const fallbacks = ['.buy-buttons', '.product-form', '.product-information'];
      for (const selector of fallbacks) {
        triggerElement = document.querySelector(selector);
        if (triggerElement) {
          console.log('Found trigger element:', selector);
          break;
        }
      }
    } else {
      console.log('Found product-form-component as trigger');
    }
    
    return triggerElement;
  };
  
  const triggerElement = await findTriggerElement();
  
  if (!triggerElement) {
    console.warn('No trigger element found');
    return;
  }
  
  // Scroll handler function
  function handleScroll() {
    const triggerRect = triggerElement.getBoundingClientRect();
    const isOffScreen = triggerRect.bottom < 0;
    
    if (isOffScreen && !stickyBar.classList.contains('is-visible')) {
      console.log('Trigger element scrolled off screen, showing sticky bar');
      stickyBar.classList.add('is-visible');
      document.body.classList.add('sticky-product-bar-visible');
    } else if (!isOffScreen && stickyBar.classList.contains('is-visible')) {
      console.log('Trigger element back on screen, hiding sticky bar');
      stickyBar.classList.remove('is-visible');
      document.body.classList.remove('sticky-product-bar-visible');
    }
  }
  
  // Add scroll listener
  window.addEventListener('scroll', handleScroll);
  
  // Initial check
  handleScroll();
  
  // Handle variant selection for kit template
  const variantSelect = stickyBar.querySelector('.sticky-product-bar__variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function(event) {
      const selectedValue = event.target.value;
      const selectedOption = event.target.selectedOptions[0];
      const variantId = selectedOption.getAttribute('data-variant-id');
      
      console.log('Sticky bar variant changed to:', selectedValue, 'ID:', variantId);
      
      // Update the hidden variant ID input in sticky bar immediately
      const variantIdInput = stickyBar.querySelector('.product-variant-id');
      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }
      
      // Get variant data and update price immediately
      if (variantId) {
        updateStickyBarPrice(variantId);
      }
      
      // Update the main product form variant picker
      const mainVariantPicker = document.querySelector('variant-picker');
      if (mainVariantPicker) {
        const mainInputs = mainVariantPicker.querySelectorAll('input[type="radio"], select');
        mainInputs.forEach(function(input) {
          if (input.value === selectedValue) {
            if (input.type === 'radio') {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (input.tagName === 'SELECT') {
              input.value = selectedValue;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      }
    });
  }
  
  // Function to update price and availability based on variant ID
  function updateStickyBarPrice(variantId) {
    // Get variant data from the main product form's JSON script
    const mainVariantPicker = document.querySelector('variant-picker');
    if (mainVariantPicker) {
      const variantScript = mainVariantPicker.querySelector('script[type="application/json"]');
      if (variantScript) {
        try {
          const currentVariant = JSON.parse(variantScript.textContent);
          
          // Fetch the product data to get all variants
          fetch(window.location.pathname + '.js')
            .then(response => response.json())
            .then(productData => {
              const selectedVariant = productData.variants.find(v => v.id == variantId);
              
              if (selectedVariant) {
                // Update price display
                const priceElement = stickyBar.querySelector('.sticky-product-bar__price-current');
                if (priceElement) {
                  const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  });
                  const price = selectedVariant.price / 100;
                  priceElement.textContent = formatter.format(price);
                }
                
                // Update add to cart button state
                const addButton = stickyBar.querySelector('.sticky-product-bar__add-to-cart');
                if (addButton) {
                  const buttonText = addButton.querySelector('span');
                  if (selectedVariant.available) {
                    addButton.disabled = false;
                    buttonText.textContent = hasUpsells ? 'View options' : 'Add to cart';
                  } else {
                    addButton.disabled = true;
                    buttonText.textContent = 'Sold out';
                  }
                }
                
                console.log('Updated sticky bar with variant:', selectedVariant);
              }
            })
            .catch(error => {
              console.error('Error fetching product data:', error);
            });
        } catch (error) {
          console.error('Error parsing variant data:', error);
        }
      }
    }
  }
  
  // Function to update variant ID based on selected option
  function updateStickyBarVariant(selectedValue) {
    // This will be updated by the main variant picker events
    // We'll listen for variant changes from the main picker
  }
  
  // Listen for variant changes from the main product form
  document.addEventListener('variant:change', function(event) {
    console.log('Main variant changed:', event.detail);
    
    if (event.detail && event.detail.variant) {
      // Update the sticky bar variant select if it exists
      if (variantSelect && event.detail.selectedOptions) {
        const firstOption = Object.values(event.detail.selectedOptions)[0];
        if (firstOption && variantSelect.value !== firstOption) {
          variantSelect.value = firstOption;
        }
      }
      
      // Update the hidden variant ID input in sticky bar
      const variantIdInput = stickyBar.querySelector('.product-variant-id');
      if (variantIdInput && event.detail.variant.id) {
        variantIdInput.value = event.detail.variant.id;
      }
      
      // Update price display with proper formatting
      const priceElement = stickyBar.querySelector('.sticky-product-bar__price-current');
      if (priceElement && event.detail.variant.price) {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        });
        const price = event.detail.variant.price / 100;
        priceElement.textContent = formatter.format(price);
      }
      
      // Update add to cart button state
      const addButton = stickyBar.querySelector('.sticky-product-bar__add-to-cart');
      if (addButton) {
        const buttonText = addButton.querySelector('span');
        if (event.detail.variant.available) {
          addButton.disabled = false;
          buttonText.textContent = hasUpsells ? 'View options' : 'Add to cart';
        } else {
          addButton.disabled = true;
          buttonText.textContent = 'Sold out';
        }
      }
    }
  });

  // Handle add to cart form submission
  const form = stickyBar.querySelector('form');
  if (form) {
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      
      const addButton = stickyBar.querySelector('.sticky-product-bar__add-to-cart');
      const originalText = addButton.querySelector('span').textContent;
      
      // If upsells exist, scroll to main product form instead of adding to cart
      if (hasUpsells) {
        // Find the main product form buttons
        const mainFormSelectors = [
          '.product-form-buttons',
          '.product-form__buttons',
          '.buy-buttons-block',
          'product-form',
          '[data-product-form]'
        ];
        
        let targetElement = null;
        for (const selector of mainFormSelectors) {
          targetElement = document.querySelector(selector);
          if (targetElement) {
            console.log('Found target element:', selector);
            break;
          }
        }
        
        if (targetElement) {
          // Scroll to the element
          targetElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center'
          });
          
          // Optional: Add visual feedback
          addButton.querySelector('span').textContent = 'View Options';
          setTimeout(function() {
            addButton.querySelector('span').textContent = originalText;
          }, 1000);
        }
        return;
      }
      
      // Normal add to cart behavior (no upsells)
      const variantId = form.querySelector('input[name="id"]').value;
      const quantity = 1;
      
      addButton.disabled = true;
      addButton.querySelector('span').textContent = 'Adding...';
      
      // Use modern cart API with JSON body
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ 
            id: parseInt(variantId), 
            quantity: quantity 
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          // Handle error
          console.error('Cart error:', data.message);
          addButton.querySelector('span').textContent = 'Error';
          setTimeout(function() {
            addButton.disabled = false;
            addButton.querySelector('span').textContent = originalText;
          }, 2000);
          return;
        }
        
        addButton.querySelector('span').textContent = 'Added!';
        
        // Dispatch CartAddEvent to trigger cart drawer
        const cartAddEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'sticky-product-bar',
            data: {
              source: 'sticky-product-bar',
              itemCount: quantity,
              productId: form.closest('[data-product-id]')?.dataset.productId
            }
          }
        });
        document.dispatchEvent(cartAddEvent);
        
        // Also try to open cart drawer directly if it exists
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        
        setTimeout(function() {
          addButton.disabled = false;
          addButton.querySelector('span').textContent = originalText;
        }, 1500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        addButton.disabled = false;
        addButton.querySelector('span').textContent = originalText;
      });
    });
  }
  
  // Cleanup on page unload to prevent memory leaks
  window.addEventListener('beforeunload', function() {
    window.removeEventListener('scroll', handleScroll);
    document.body.classList.remove('has-sticky-product-bar', 'sticky-product-bar-visible');
  });
  
});

  } catch(e) { console.error(e); }
})();
})();
